import { getDomain } from 'tldts';

export function extractDomain(url: string): string | null {
  if (!url) {
    return null;
  }

  try {
    return getDomain(url.trim(), {
      allowPrivateDomains: true,
      extractHostname: true,
    });
  } catch {
    return null;
  }
}
